import React from "react";
import { PlusIcon } from "../icons";

interface OptionalItem {
  id: string;
  title: string;
  unitPrice: number;
  quantity: number;
  totalPrice: number;
  categoryOption?: {
    id: string;
    name: string;
    optionType: string;
  };
}

interface PublicOptionalItemsSummaryProps {
  optionalItems: OptionalItem[];
}

const PublicOptionalItemsSummary: React.FC<PublicOptionalItemsSummaryProps> = ({
  optionalItems,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("pl-PL", {
      style: "currency",
      currency: "PLN",
      currencyDisplay: "code",
    }).format(amount);
  };

  const grandTotal = optionalItems.reduce(
    (sum, item) => sum + (Number(item.totalPrice) || 0),
    0
  );

  if (optionalItems.length === 0) {
    return null;
  }

  return (
    <div className="mb-8" data-section="optional-items-summary">
      {/* Header */}
      <div className="mb-6">
        <h2
          className="text-xl font-semibold mb-4 flex items-center gap-2"
          style={{ color: "var(--gradient-start, #334155)" }}
        >
          <PlusIcon
            className="w-5 h-5"
            style={{ color: "var(--gradient-start, #64748b)" }}
          />
          Opcje Dodatkowe
        </h2>
        <p className="text-sm text-gray-600">
          Sugerowane usługi dodatkowe - nie są wliczone do wyceny podstawowej
        </p>
      </div>

      {/* Simple Table */}
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {/* Table header */}
        <div className="grid grid-cols-[2fr_80px_100px_130px] text-sm font-semibold text-slate-700 bg-slate-50 border-b border-slate-200">
          <div className="p-4 text-left">Nazwa usługi</div>
          <div className="p-4 text-center">Ilość</div>
          <div className="p-4 text-right">Cena jedn.</div>
          <div className="p-4 text-right">Razem</div>
        </div>

        {/* Table rows */}
        {optionalItems.map((item) => (
          <div
            key={item.id}
            className="grid grid-cols-[2fr_80px_100px_130px] text-sm border-b border-slate-100 hover:bg-slate-50"
          >
            <div className="p-4 text-left font-medium text-slate-900">
              {item.title}
            </div>
            <div className="p-4 text-center text-slate-600">
              {item.quantity}
            </div>
            <div className="p-4 text-right text-slate-600">
              {formatCurrency(item.unitPrice)}
            </div>
            <div className="p-4 text-right font-semibold text-slate-900">
              {formatCurrency(Number(item.totalPrice) || 0)}
            </div>
          </div>
        ))}

        {/* Table footer */}
        <div
          className="grid grid-cols-[2fr_80px_100px_130px] text-white font-bold"
          style={{
            background: `linear-gradient(135deg, var(--gradient-start, #334155) 0%, var(--gradient-end, #1e293b) 100%)`,
          }}
        >
          <div className="p-4 text-left">RAZEM OPCJE:</div>
          <div className="p-4"></div>
          <div className="p-4"></div>
          <div className="p-4 text-right text-lg">
            {formatCurrency(grandTotal)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicOptionalItemsSummary;
